import { AppHeader } from "@/components/app-header";
import { AppFooter } from "@/components/app-footer";
import type { PageFaq } from "@/lib/pages";
import type { CompareRoundupConfig } from "./roundup-types";
import { COMPARE_PRICE_PARAMS } from "@/lib/compare-offers";
import { HeroSection } from "./hero-section";
import { StatsSection } from "./stats-section";
import { RankingSection } from "./ranking-section";
import { RoundupTableSection } from "./roundup-table-section";
import { RelatedSection } from "./related-section";
import { FaqSection } from "./faq-section";
import { CtaSection } from "./cta-section";
import { ShareSection } from "./share-section";
import "@/styles/company-pages.css";
import "@/styles/compare.css";

/**
 * Renders a "best <product> alternatives" roundup page from a
 * `CompareRoundupConfig`. Hero, stats, FAQ and CTA are the same sections the
 * head-to-head `CompareLandingPage` uses; the ranked list and the N-column
 * matrix are what make it a roundup. Optional sections (`stats`, `related`)
 * render nothing when omitted from the config.
 */
export function RoundupLandingPage({
  config,
  faqs,
  offersAsOf,
}: {
  config: CompareRoundupConfig;
  faqs?: PageFaq[];
  /** Loader-supplied `YYYY-MM-DD` that decides whether an intro offer has ended. */
  offersAsOf: string;
}) {
  return (
    <div className="company-page compare-page">
      <AppHeader />
      <main id="main">
        <HeroSection config={config} priceParams={COMPARE_PRICE_PARAMS} />
        <StatsSection config={config} />
        <RoundupTableSection config={config} offersAsOf={offersAsOf} />
        <RankingSection config={config} offersAsOf={offersAsOf} />
        <RelatedSection config={config} />
        <FaqSection faqs={faqs} />
        <ShareSection config={config} />
        <CtaSection config={config} />
      </main>
      <AppFooter />
    </div>
  );
}
